import React from "react";
import Hero from "../components/Hero/Hero";
import About from "../components/About/About";
import Services from "../components/Services/Services";
import ComplianceTeaser from "../components/ComplianceTeaser/ComplianceTeaser";
import Contact from "../components/Contact/Contact";

function Home() {
  return (
    <main>
      <Hero />
      <About />
      <Services />
      <ComplianceTeaser />
      <Contact />
    </main>
  );
}

export default Home;
